import { WheelRaffleItemStatus } from "./types";

export const WHEEL_RAFFLE_STATUS_LABELS: Record<WheelRaffleItemStatus, string> =
  {
    [WheelRaffleItemStatus.SCHEDULED]: "Scheduled",
    [WheelRaffleItemStatus.LIVE]: "Live",
    [WheelRaffleItemStatus.ENDED]: "Ended",
    [WheelRaffleItemStatus.DRAWN]: "Drawn",
  };

// Окно истории: recent отдаёт текущие + разыгранные за последние N дней.
export const RAFFLE_HISTORY_DAYS = 30;
